import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import classNames from 'classnames';
import Translate from '../../../components/translate/Translate';
import React from 'react';
import {SurveyModalProps} from '../SurveyModal.component';

@observer
export class SurveyModalContent extends TechseeBaseComponent<SurveyModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        // Access observables to create MobX dependencies
        const questions = ctrl.questions.slice();

        return (
            <div className='modal-body'>
                {questions.map((questionData) => (
                    <div key={questionData._id} className='question'>
                        {questionData.answerType === ctrl.ANSWER_TYPES.OPEN && (
                            <textarea
                                name={`${questionData._id}-answer`}
                                id={`${questionData._id}-answer`}
                                value={(questionData.answer as string) || ''}
                                onChange={(e) => ctrl.updateQuestionAnswer(questionData._id, e.target.value)}
                                placeholder={questionData.question}
                                maxLength={ctrl.SURVEY_ANSWER_MAX_LENGTH || 2000}
                            />
                        )}
                        {questionData.answerType !== ctrl.ANSWER_TYPES.OPEN && (
                            <>
                                <p
                                    className={classNames('question-label', {
                                        multiselect: questionData.answerType === ctrl.ANSWER_TYPES.SELECT
                                    })}>
                                    {questionData.question}
                                </p>
                                {questionData.answerType === ctrl.ANSWER_TYPES.YES_NO && (
                                    <div className={classNames('options', 'yes-no', {left: ctrl.dir === 'rtl'})}>
                                        <div className='answer'>
                                            <label htmlFor={`${questionData._id}-yes`}>
                                                <Translate text='DASHBOARD.SURVEY.YES' />
                                            </label>
                                            <input
                                                type='radio'
                                                className='radio'
                                                name={questionData._id}
                                                id={`${questionData._id}-yes`}
                                                checked={questionData.answer === true}
                                                onChange={() => ctrl.updateQuestionAnswer(questionData._id, true)}
                                            />
                                        </div>
                                        <div className='answer'>
                                            <label htmlFor={`${questionData._id}-no`}>
                                                <Translate text='DASHBOARD.SURVEY.NO' />
                                            </label>
                                            <input
                                                type='radio'
                                                className='radio'
                                                name={questionData._id}
                                                id={`${questionData._id}-no`}
                                                checked={questionData.answer === false}
                                                onChange={() => ctrl.updateQuestionAnswer(questionData._id, false)}
                                            />
                                        </div>
                                    </div>
                                )}
                                {questionData.answerType === ctrl.ANSWER_TYPES.SELECT && (
                                    <div className={classNames('options', 'select', {left: ctrl.dir === 'rtl'})}>
                                        <div className='answer'>
                                            <select
                                                value={(questionData.answer as string) || ''}
                                                name={questionData._id}
                                                id={questionData._id}
                                                onChange={(e) =>
                                                    ctrl.updateQuestionAnswer(questionData._id, e.target.value)
                                                }>
                                                {questionData.options?.map((option, index) => (
                                                    <option key={index} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                ))}
            </div>
        );
    }
}
